<template>
  <teleport to="#teleport">
    
      <div class="popup-profile">
        <transition name="transition-fade" appear>
          <div class="popup-content" @click="$emit('close')">
            
            <NuxtLink :to="useAuth().getLink()" class="profile-link">
              <i class="icon-user"></i>
              View My Profile
            </NuxtLink>
            
            <NuxtLink :to="useAuth().getLink() + '/settings'" class="profile-link">
              <i class="icon-pencil"></i>
              Edit Profile
            </NuxtLink>
            
            <NuxtLink :to="'/diaries/edit/new'" class="profile-link">
              <i class="icon-plus"></i>
              {{ $t('main_menu_start_diary') }}
            </NuxtLink>


            <NuxtLink 
              v-if="useAuth().isAuth() && useAuth().getAccess('view_extra')" 
              :to="useAuth().getLink() + '/shorts?eed=true'"
              class="profile-link" 
              >
              <i class="icon-shorts"></i> 
              Create Short
            </NuxtLink>

          
            <div @click="useAuth().logout({redirect: true})" class="profile-link logout-btn">
              <i class="icon-logout"></i>
              Logout
            </div>
          
          </div>
        </transition>
        <div class="popup-overlay" @click="$emit('close')"></div>
      </div>
    
  </teleport>
</template>

<script setup lang="ts">


const emit = defineEmits(['close'])

</script>

<style scoped>
.popup-profile {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
 

.popup-content {
  background: var(--un-background-color-gray-light);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  padding: 0.3rem 0.6rem;
  margin-top: 52px;
  margin-right: 20px;
}
 
 
 

.profile-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.profile-links li {
  margin: 0;
}

.profile-link {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0.7rem 0.8rem;
  text-decoration: none;
  color: var(--un-text-color);
  font-weight: 500;
  transition: background-color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}
 

.link-icon {
  margin-right: 12px;
  font-size: 18px;
}

.logout-btn {
  border-top: 1px solid var(--un-element-color-gray-light);
}

/* anumation */


 

@media (prefers-color-scheme: dark) {
  
}
</style>
